import React, { ReactNode } from 'react';
import TopNavigation from '../../components/TopNavigation';
import Footer from 'parent-portal/shared/Footer/Footer';
import PublicFooter from 'parent-portal/shared/PublicFooter';
import { useUserContext } from 'UserContext';
import { BusinessLayout } from './BusinessLayout';

const DEFAULT_BUSINESS_ROLES = new Set(['business', 'business_active']);

interface PublicOrBusinessLayoutProps {
    children: ReactNode;
    businessRoles?: ReadonlySet<string>;
}

function PublicMarketingLayout({ children }: { children: ReactNode }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <TopNavigation />
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>{children}</div>
            <Footer />
            <div style={{ position: 'fixed', bottom: 0, right: 0 }}>
                <PublicFooter />
            </div>
        </div>
    );
}

export function PublicOrBusinessLayout({
    children,
    businessRoles = DEFAULT_BUSINESS_ROLES,
}: PublicOrBusinessLayoutProps) {
    const { user, role } = useUserContext();
    const hasToken = localStorage.getItem('token') !== null;

    if (hasToken && !user) {
        return null;
    }

    if (hasToken && role && businessRoles.has(role)) {
        return <BusinessLayout>{children}</BusinessLayout>;
    }

    return <PublicMarketingLayout>{children}</PublicMarketingLayout>;
}
